import { render, staticRenderFns } from "./ModifyEmail.vue?vue&type=template&id=728c0cdf&scoped=true"
import script from "./ModifyEmail.vue?vue&type=script&lang=js"
export * from "./ModifyEmail.vue?vue&type=script&lang=js"
import style0 from "./ModifyEmail.vue?vue&type=style&index=0&id=728c0cdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728c0cdf",
  null
  
)

export default component.exports